import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/main.css'
import './assets/styles/variables.css'
import '@fortawesome/fontawesome-free/css/all.css'
import { registerSW } from 'virtual:pwa-register'


const app = createApp(App)

app.use(router)
app.use(store) // Vuex store 사용

if ('serviceWorker' in navigator) {
  // 컨트롤러 바뀌면 자동 새로고침 → 강제 적용
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}

// 폰트 크기 조절
const fontScale = parseFloat(localStorage.getItem('fontScale') || '1')
document.documentElement.style.setProperty(
  '--font-scale',
  isNaN(fontScale) ? '1' : fontScale.toString(),
)

// 쿼리에서 accessToken 있으면 로컬스토리지에 저장
const url = new URL(window.location.href)
const tokenFromQuery = url.searchParams.get('accessToken')
if (tokenFromQuery) {
  console.log('[initializeAuth] 쿼리에서 accessToken 복원:', tokenFromQuery)
  localStorage.setItem('accessToken', tokenFromQuery)
}

// Firebase 인증 상태 초기화 및 감지 시작
store.dispatch('initializeAuth').then(() => {
  app.mount('#app')
})

// 앱 종료, 새로고침, 백그라운드 전환 시 사용자 정보 저장 리스너 추가
window.addEventListener('beforeunload', () => {
  store.dispatch('saveUserBeforeUnload')
})

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    // 페이지가 백그라운드로 전환될 때
    console.log('페이지 가시 상태 변경: hidden. 사용자 정보 저장 시도.')
    store.dispatch('saveUserBeforeUnload') // 기존 저장 액션 재활용
  }
})

// PWA 업데이트 알림 콜백 저장용
let updateCallback = null
export function onServiceWorkerUpdate(callback) {
  updateCallback = callback
}

// PWA 서비스워커 등록
export const updateSW = registerSW({
  immediate: true,

  onNeedRefresh() {
    console.log('[PWA] 새로운 버전 감지 — 강제 적용')
    // 완전 자동 강제 적용:
    updateSW(true)  // skipWaiting → controllerchange → reload

    // 사용자 확인 UI가 필요한 경우:
    // if (updateCallback) updateCallback(() => updateSW(true))
  },
  onOfflineReady() {
    console.log('[PWA] 오프라인 실행 준비 완료')
  },
  onRegisterError(err) {
    console.error('[PWA] SW 등록 오류:', err)
  },
})

// PWA 설치 이벤트들
window.deferredPwaPrompt = null

window.addEventListener('beforeinstallprompt', (e) => {
  console.log('[PWA] beforeinstallprompt 이벤트 발생')
  e.preventDefault()
  window.deferredPwaPrompt = e
})

window.addEventListener('appinstalled', () => {
  console.log('[PWA] 앱이 설치되었습니다.')
  localStorage.setItem('pwaInstalled', 'true')
  sessionStorage.removeItem('pwaInstallModalLater')
})

export function getDeferredPrompt() {
  return window.deferredPwaPrompt
}
